import React from 'react';
import PropTypes from 'prop-types';

const inputStyles =
  'w-full mt-1 p-2 border rounded-md px-3 py-2 focus:outline-none focus:ring-1 focus:border-green-800 focus:ring-green-500';
const InputComponent = props => {
  return <input {...props} className={`${inputStyles} ${props.className}`} />;
};

InputComponent.propTypes = {
  type: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  className: PropTypes.string
};

InputComponent.defaultProps = {
  placeholder: '',
  type: 'text'
};

export default InputComponent;
